import { render, staticRenderFns } from "./SampleImageList2.vue?vue&type=template&id=761e10c3&scoped=true&"
import script from "./SampleImageList2.vue?vue&type=script&lang=js&"
export * from "./SampleImageList2.vue?vue&type=script&lang=js&"
import style0 from "./SampleImageList2.vue?vue&type=style&index=0&id=761e10c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761e10c3",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QImg,QItem,QItemSection,QIcon,QSeparator});qInstall(component, 'directives', {Ripple});
